import React, { useEffect, useRef, useState } from "react";
import pageHeadingStyles from "../../../styles/PageHeader.module.scss";
import styles from "./styles.module.scss";
import SearchInput from "../../../components/SearchInput/SearchInput";
import useEmsOfficeStore from "../../../stores/ems-office"; 
import Button from "../../../components/new-button";
import PlusIcon from "../../../assets/svg/icons/common/Plus";

const Header = () => {
  const [searchValue, setSearchValue] = useState("");

  const setSearchFilters = useEmsOfficeStore((state) => state.setSearchFilters);
  const searchFilters = useEmsOfficeStore((state) => state.searchFilters);

  const setIsAddEmsOfficeModalOpen = useEmsOfficeStore((state) => state.setIsAddEmsOfficeModalOpen);

  const timerRef = useRef(null);

  const handleChange = (e) => {
    setSearchValue(e.target.value);
  };

  useEffect(() => {
    timerRef.current = setTimeout(() => {
      setSearchFilters({
        ...searchFilters,
        search: searchValue
      });
    }, 300);

    return () => {
      clearTimeout(timerRef.current);
    };
  }, [searchValue]);

  return (
    <div className={`${pageHeadingStyles.page_heading} ${pageHeadingStyles.column}`}>
      <div className={styles.headerRow}>
        <div className={pageHeadingStyles.title_contents}>
          <p>Kurv Offices</p>
        </div>
        <div className={styles.right_side}>
          <Button variant="primary" onClick={() => setIsAddEmsOfficeModalOpen(true)}>
            <PlusIcon />
            <span>Add Kurv Office</span>
          </Button>
        </div>
      </div>
      <div className={styles.searchInputContainer}>
        <SearchInput value={searchValue} onChange={handleChange} />
      </div>
    </div>
  );
};

export default Header;
